module.exports = __webpack_public_path__ + "img/xpeng-park.068e142d.jpg";